import { t } from "@lingui/macro";
import { useEffect, useRef } from "react";
import { useBlocker } from "react-router";

import type { AutoSaveStatus } from "./use-auto-save";

/** Flush a pending edit before an in-app exit, with one decision per blocked attempt. */
export const useBlockedSaveNavigation = (status: AutoSaveStatus, flush: () => Promise<boolean>) => {
  const handling = useRef(false);
  const blocker = useBlocker(status !== "saved");

  useEffect(() => {
    if (blocker.state === "unblocked") {
      handling.current = false;
      return;
    }
    if (blocker.state !== "blocked" || handling.current) return;
    handling.current = true;

    void flush().then((saved) => {
      if (saved) {
        blocker.proceed();
      } else if (window.confirm(t`Your latest changes could not be saved. Leave without saving?`)) {
        blocker.proceed();
      } else {
        blocker.reset();
      }
    });
  }, [blocker, flush]);
};
